var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"under-maintenance"},[_c('img',{staticClass:"maintenance-image",attrs:{"src":"/static/icons8-maintenance-100.png","alt":"Em manutenção"}}),_vm._v(" "),_c('p',[_vm._v("O site está em manutenção. Por favor, volte mais tarde.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f86db3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/UnderMaintenance.vue
// module id = 1127
// module chunks = 0